export default "__VITE_ASSET__C$$Bg3V0__"